<div class="wrapper animated fadeIn">
    <div class="row">
        <div class="col-sm-12 wtw-hero-image">
            <img id="BGprincipal" class="img-responsive" src="assets/global/images/cabeceras/bg_admin_parametricas.jpg">
            <h1 class="wtw-bg-black col-lg-5" style="margin-left: 15px">Administración</h1>
        </div>
    </div>
    <!-- end .row -->

    <div class="container-fluid">

        <!-- Page-Title -->
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="btn-group pull-right">
                        <ol class="breadcrumb hide-phone p-0 m-0">
                            <li class="breadcrumb-item"><a href="#">Inicio</a></li>
                            <li class="breadcrumb-item"><a href="#">Administración</a></li>
                            <li class="breadcrumb-item"><a href="#">Paramétricas</a></li>
                        </ol>
                    </div>
                    <h4 class="page-title">Administración Paramétricas</h4>
                </div>
            </div>
        </div>
        <!-- end page title end breadcrumb -->
        <!--/ end row -->

        <div class="col-lg-12">
            <div class="card-box ribbon-box">
                <div class="ribbon ribbon-purple">E-Global</div>
                <div class="row">

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/city"]'> <button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Ciudades</span> </button></a>
                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/aseguradora"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Aseguradoras</span> </button></a>
                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/ramo"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Ramo</span> </button></a>
                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/regional"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Regional</span> </button></a>
                    </div>
                    <!-- end col -->


                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/centroCosto"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Centro Costos</span> </button></a>
                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/uen"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>UEN</span> </button></a>
                    </div>
                    <!-- end col -->
                </div>
            </div>

            <div class="card-box ribbon-box">
                <div class="ribbon ribbon-purple">Portal</div>
                <div class="row">

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/amparos"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Amparos</span> </button></a>
                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/categoria"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Categoría</span> </button></a>

                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/estado"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Estados</span> </button></a>
                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/documento-siniestro"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Documento Siniestros</span> </button></a>
                    </div>
                    <!-- end col -->

                    <div class="col-sm-3">
                        <a [routerLink]='["/admin/contacto-aseguradora"]'><button type="button" class="btn btn-light btn btn-block waves-effect waves-light">
                            <span>Contacto Aseguradoras</span> </button></a>
                    </div>
                    <!-- end col -->

                </div>
            </div>
            <!-- end row -->
            <div class="blanco"></div>

        </div>
        <!-- end container -->
    </div>
</div>